import { render, staticRenderFns } from "./CaseOnsite.vue?vue&type=template&id=72757a30&"
import script from "./CaseOnsite.vue?vue&type=script&lang=js&"
export * from "./CaseOnsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports